import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../auth/api/service/auth.service';
import {Subscription} from 'rxjs';
import {Operator, Order, Sort} from '../../../../../../shared/utils/url.builder';
import {UrlParameterBuilder} from '../../../../../core/http/UrlParameterBuilder';
import {DocumentPaginatedService} from '../../../../../document/common/api/service/documentPaginated.service';
import {DocumentFormat, DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';
import {Pageable} from '../../../../../../shared/model/core/pageable.model';
import {AbstractActionService} from "../../../../../core/service/v2/service/action/abstractAction.service";
import {
  WithReportFormatContentPayload
} from "../../../../../reporting/report/impl/service/payload/withReportFormatContent.payload";
import {
  DocumentStickyPaginatedService
} from "../../../../../document/common/api/service/documentStickyPaginated.service";
import {BaseView} from "../../../../../core/view/base.view";
import {
  CommunicationConfigurationEmailSenderSummaryModel
} from "../../../../configuration/email/sender/api/entity/communicationConfigurationEmailSenderSummary.model";
import {
  CommunicationConfigurationEmailSenderFindOneByIdService
} from "../../../../configuration/email/sender/api/service/communicationConfigurationEmailSenderFindOneById.service";

@Component({
  selector: 'app-email-content-form',
  templateUrl: './email-content-form.component.html',
  providers: [
    DocumentPaginatedService,
    DocumentStickyPaginatedService,
  ]
})
export class EmailContentFormComponent extends BaseView implements OnChanges, OnDestroy {

  @Input() formGroup: UntypedFormGroup;
  @Input() initialTo: string;
  @Input() initialSubject: string;
  @Input() initialContent: string;
  @Input() canAddDocuments = false;
  @Input() partnerId;
  @Input() formatContentService: AbstractActionService<WithReportFormatContentPayload, any>;
  @Input() buildFormatContentPayload: () => WithReportFormatContentPayload;
  @Input() substitutionAdditionalCategoryValues: string [] = [];

  stickyDocuments: DocumentSummaryModel[] = [];
  partnerDocuments: DocumentSummaryModel[] = [];
  documents: DocumentSummaryModel[] = [];
  configurations: CommunicationConfigurationEmailSenderSummaryModel[] = [];
  subscriptions: Subscription[] = [];

  constructor(private formBuilder: UntypedFormBuilder,
              private authService: AuthService,
              public documentPaginatedService: DocumentPaginatedService,
              public stickyPaginatedService: DocumentStickyPaginatedService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.formGroup.removeControl('subject');
      this.formGroup.removeControl('content');
      this.formGroup.removeControl('to');
      this.formGroup.removeControl('senderConfigId');
      this.formGroup.removeControl('documentIds');
      this.formGroup.addControl('to', this.formBuilder.control(undefined, Validators.required));
      this.formGroup.addControl('senderConfigId', this.formBuilder.control(undefined));
      this.formGroup.addControl('subject', this.formBuilder.control(undefined, Validators.required));
      this.formGroup.addControl('content', this.formBuilder.control(undefined, Validators.required));
      this.formGroup.addControl('documentIds', this.formBuilder.control([]));
    }
    if (changes['initialTo']) {
      this.formGroup.get('to').setValue(this.initialTo);
    }
    if (changes['initialSubject']) {
      this.formGroup.get('subject').setValue(this.initialSubject);
    }
    if (changes['initialContent']) {
      this.formGroup.get('content').setValue(this.initialContent?.replace("\n", "<br/>"));
    }
    if (changes['canAddDocuments'] || changes['partnerId']) {
      if (this.canAddDocuments === true) {

        if (this.partnerId) {
          this.documentPaginatedService.findPaginated(Pageable.ofWithSort(0, 50, new Sort('createdAt', Order.DESCENDING)),
              new UrlParameterBuilder()
                  .addParameter('partner.id', this.partnerId, Operator.EQUALS)
                  .parameters)
              .then(value => {
                this.partnerDocuments = value.content.map(value1 => value1.summary);
                this.buildDocuments();
              });
        }
        this.stickyPaginatedService.findPaginated(Pageable.ofWithSort(0, 50, new Sort('label', Order.ASCENDING)))
            .then((value => {
              this.stickyDocuments = value.content.map(value1 => value1.summary);
              this.buildDocuments();
            }));
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(value => value?.unsubscribe());
  }

  buildDocuments() {
    this.documents = [];
    this.stickyDocuments?.forEach(value => this.documents.push(value));
    this.partnerDocuments?.forEach(value => this.documents.push(value))
    this.documents = this.documents.filter(value => value.format?.value !== DocumentFormat.JSON);
  }

  configurationsLoaded(values: CommunicationConfigurationEmailSenderSummaryModel[]) {
    this.configurations = values;
    if (values?.length > 0) {
      let selected = values.find(value => value.owner && value.owner.id === this.authService.userSnapshot?.summary.id);
      if (! selected) {
        selected = values.find(value => ! value.owner);
      }
      if (selected) {
        this.formGroup.patchValue({
          senderConfigId: selected?.id
        });
      }
    }
  }
}
